// HOZZÁJÁRULÁS AZ AI-FELDOLGOZÁSHOZ — webes oldal.
//
// ÉLES KÖVETELMÉNYBŐL. Az App Review a mobil 1.0.36-ot az 5.1.1(i) és
// 5.1.2(i) irányelvre hivatkozva utasította el: az app harmadik féltől
// származó AI-szolgáltatásnak ad át személyes adatot anélkül, hogy megmondaná,
// mit, kinek, és engedélyt kérne rá. Ugyanaz a végpont fut a weben is, tehát
// ugyanaz a kötelezettség.
//
// AMI A WEBRŐL ELMEGY: CSAK a beírt szöveg. A mobil a munkatársak nevét is
// küldi (hogy a modell felelőst rendeljen), a web nem — a `captureWithAi` a
// `{ text }` alakot hívja. A tájékoztatás ezért itt szűkebb, és ez nem
// pongyolaság: többet állítani, mint ami történik, ugyanúgy félrevezetés.
// Emiatt van két web-specifikus kulcs (`consentWhatNotWeb`, `consentRevokeWeb`)
// a mobilos párjuk helyett.
//
// A DÖNTÉS A BÖNGÉSZŐBEN marad, felhasználónként. Más gépen újra kérdezünk.

import { h } from './dom';
import { openDialog } from './dialog';
import { t } from './i18n';

const KULCS_ELOTAG = 'blaze.ai-hozzajarulas.';

/// Megadta-e már ez a felhasználó EBBEN a böngészőben.
///
/// Hiba esetén `false`: ha nem tudjuk biztosan, hogy hozzájárult, megkérdezzük.
/// A fordítottja — kétség esetén küldeni — pont az, amit az irányelv tilt.
export function vanAiHozzajarulas(uid: string): boolean {
  if (!uid) return false;
  try {
    return localStorage.getItem(KULCS_ELOTAG + uid) === 'igen';
  } catch {
    return false;
  }
}

export function adjAiHozzajarulast(uid: string): void {
  if (!uid) return;
  try {
    localStorage.setItem(KULCS_ELOTAG + uid, 'igen');
  } catch {
    /* Nem marad meg; legközelebb újra kérdezünk. Biztonságos irányba téved. */
  }
}

export function vondVisszaAiHozzajarulast(uid: string): void {
  if (!uid) return;
  try {
    localStorage.removeItem(KULCS_ELOTAG + uid);
  } catch {
    /* ugyanaz */
  }
}

function tetel(szoveg: string): HTMLElement {
  return h(
    'div',
    { class: 'row g8', style: { alignItems: 'flex-start' } },
    h('span', { style: { color: 'var(--accent)', lineHeight: '1.5' }, text: '→' }),
    h('span', { class: 'body-sm ts', text: szoveg }),
  );
}

/// Megjeleníti a hozzájárulást kérő ablakot.
///
/// A `Promise` `true`-val tér vissza, ha a felhasználó elfogadta. Minden más
/// esetben — elutasítás, Esc, kattintás a háttérre — `false`.
export function kerjAiHozzajarulast(): Promise<boolean> {
  return new Promise((kesz) => {
    let elfogadta = false;

    openDialog({
      title: t('ai.consentTitle'),
      width: '520px',
      body: () =>
        h(
          'div',
          { class: 'col g16' },
          h('p', {
            class: 'body ts',
            style: { margin: '0' },
            text: t('ai.consentLead'),
          }),
          h(
            'div',
            { class: 'sunken col g8', style: { padding: '14px', border: '1px solid var(--border)' } },
            h('span', { class: 'label ts', text: t('ai.consentWhatTitle') }),
            tetel(t('ai.consentWhatText')),
            h(
              'div',
              { class: 'row g8', style: { alignItems: 'flex-start' } },
              h('span', { class: 'ts', style: { lineHeight: '1.5' }, text: '⦸' }),
              h('span', {
                class: 'body-sm ts',
                style: { opacity: '.8' },
                text: t('ai.consentWhatNotWeb'),
              }),
            ),
          ),
          h(
            'div',
            {
              class: 'col g4',
              style: {
                padding: '12px',
                borderRadius: 'var(--r-md)',
                background: 'var(--info-soft)',
                border: '1px solid var(--border)',
              },
            },
            h('span', { class: 'body-sm ts', text: t('ai.consentWho') }),
          ),
          h('span', { class: 'caption ts', text: t('ai.consentRevokeWeb') }),
          h(
            'span',
            { class: 'caption ts' },
            t('ai.consentDetails'),
            h('a', { href: '#/adatkezeles', text: t('ai.consentPolicyLink') }),
          ),
        ),
      footer: (close) => [
        h('span', { class: 'grow' }),
        h('button', {
          class: 'btn btn-secondary',
          type: 'button',
          text: t('ai.consentDecline'),
          onClick: close,
        }),
        h('button', {
          class: 'btn btn-primary',
          type: 'button',
          text: t('ai.consentAccept'),
          onClick: () => {
            elfogadta = true;
            close();
          },
        }),
      ],
      // A választ a BEZÁRÁSKOR adjuk vissza, nem a gombnál: így az Esc és a
      // háttérre kattintás is „nem"-et jelent, nem beragadt ígéretet.
      onClosed: () => kesz(elfogadta),
    });
  });
}
